import { Modal, Text } from '@viapeople/components'
import { GenericTable } from '../../../components/GenericTable'
import { trpc } from '../../../utils/trpc'
import type { HierarchyItem } from '../types'

interface HierarchyDetailsModalProps {
	isOpen: boolean
	onClose: () => void
	organizationId: string
	fileId: string
}

export const HierarchyDetailsModal = ({ isOpen, onClose, organizationId, fileId }: HierarchyDetailsModalProps) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title='View hierarchy'
			fullContent
			className='md:w-300 max-w-[1110px] mx-12'>
			<GenericTable<HierarchyItem, { page: number; perPage: number }>
				columns={[
					{
						field: 'managerId',
						label: 'Manager',
						colSpan: 1,
						render: (item: HierarchyItem) => (
							<Text variant='xsmall' weight='regular'>
								{`${item.manager.firstName} ${item.manager.lastName}`}
							</Text>
						),
					},
					{
						field: 'directReportIds',
						label: 'Direct reports',
						colSpan: 1,
						render: (item: HierarchyItem) => (
							<Text variant='xsmall' weight='regular'>
								{item.directReports.map((u) => `${u.firstName} ${u.lastName}`).join(', ')}
							</Text>
						),
					},
					{
						field: 'secondaryReportIds',
						label: 'Secondary reports',
						colSpan: 1,
						render: (item: HierarchyItem) => (
							<Text variant='xsmall' weight='regular'>
								{item.secondaryReports.map((u) => `${u.firstName} ${u.lastName}`).join(', ')}
							</Text>
						),
					},
				]}
				idField='managerId'
				selectable={false}
				showSearch={false}
				showPagination={true}
				bodyClassName='max-h-[500px] overflow-y-auto'
				emptyState={{
					title: 'No hierarchy data',
					description: 'This hierarchy file appears to be empty',
				}}
				queryOptionsGenerator={(options) =>
					trpc.admin.hierarchies.list.queryOptions({
						...options,
						organizationId,
						fileId,
					})
				}
				isInternal
			/>
		</Modal>
	)
}
